import { MarathonQuestionSpecialty } from '~/common/enums/enums';

const marathonQuestionSpecialtyToLabel = {
  [MarathonQuestionSpecialty.DEFAULT]: '',
  [MarathonQuestionSpecialty.WEEKLY_CHALLENGE]: 'Weekly Challenge',
};

export { marathonQuestionSpecialtyToLabel };
